export const logout = `mutation logout{
    logout
}`;
